import { render, staticRenderFns } from "./shfx3.vue?vue&type=template&id=6753e31e&scoped=true"
import script from "./shfx3.vue?vue&type=script&lang=js"
export * from "./shfx3.vue?vue&type=script&lang=js"
import style0 from "./shfx3.vue?vue&type=style&index=0&id=6753e31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6753e31e",
  null
  
)

export default component.exports